import { render, staticRenderFns } from "./BusKnowledgeFileModal.vue?vue&type=template&id=17dbe280&"
import script from "./BusKnowledgeFileModal.vue?vue&type=script&lang=js&"
export * from "./BusKnowledgeFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports